<div fxFlex fxLayout="column">
    <div fxFlex fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column">
        <div fxFlex id="map" #map class="smap" style="position: relative; touch-action: none;">
        </div>
    </div>
</div>